import React, { useEffect, useState } from 'react'; // Bỏ useCallback nếu không dùng
import useMediaQuery from '@mui/material/useMediaQuery';
const withMediaQuery = (...queryArgs) => WrappedComponent => {
  // Định nghĩa component nội bộ ở ngoài hàm trả về của HOC chính
  // Sử dụng React.forwardRef nếu WrappedComponent cần nhận ref
  const InnerComponent = React.forwardRef((props, ref) => {
    const mediaQueryHookValue = useMediaQuery(...queryArgs);
    const [matches, setMatches] = useState(mediaQueryHookValue);

    useEffect(() => {
      let currentMatch = mediaQueryHookValue;
      // Logic ghi đè tùy chỉnh của bạn
      if (typeof window !== 'undefined' && window.innerWidth < 540) {
        currentMatch = true;
      }
      // Chỉ cập nhật state nếu giá trị thực sự thay đổi
      if (currentMatch !== matches) {
        setMatches(currentMatch);
      }

    }, [mediaQueryHookValue, matches]);

    const {forwardedRef, ...rest} = props;

    return <WrappedComponent ref={forwardedRef||ref} {...rest} mediaQueryMatches={matches} />;
  });

  // Đặt displayName cho HOC để dễ debug
  const hocDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  InnerComponent.displayName = `WithMediaQuery(${hocDisplayName})`;

  return InnerComponent;
};

export default withMediaQuery;
